export default "__VITE_ASSET__BkNefnrW__"